import { Injectable, OnInit } from '@angular/core';
import { Observable, BehaviorSubject, from } from 'rxjs';

declare var window:any;

const APPLICATION_NAME = window.WOWZA_MEDIA_APP;
const WOWZA_URL = window.WOWZA_MEDIA_SERVER_URL + '/webrtc-session.json';

@Injectable()
export class InterviewStreamService implements OnInit {

    navigator = <any>navigator;
    audioContext = null;
    localVideo = null;
    remoteVideo = null;
    peerConnection = null;
    audioMLines = null;
    peerConnectionConfig = {'iceServers': []};
    localStream = null;
    userData = {};
    wsURL = WOWZA_URL;
    wsConnection = null;
    streamName:string;
    streamInfo:any;
    videoBitrate = 360;
    audioBitrate = 64;
    videoFrameRate = '29.97';
    videoChoice = '42e01f';
    audioChoice = 'opus';
    videoIndex = -1;
    audioIndex = -1;
    userAgent = null;
    newAPI = false;
    SDPOutput = new Object();

    private _currentStream: BehaviorSubject<any> = new BehaviorSubject(null);

    constructor() {}

    get currentStream(): Observable<any> {
        return this._currentStream.asObservable();
    }

    get getStreamName() {
        return this.streamName;
    }

    ngOnInit() {
        this.navigator.mediaDevices.getUserMedia = (this.navigator.mediaDevices.getUserMedia ||
            this.navigator.mediaDevices.webkitGetUserMedia ||
            this.navigator.mediaDevices.mozGetUserMedia ||
            this.navigator.mediaDevices.msGetUserMedia);

        this.navigator.RTCPeerConnection = (this.navigator.RTCPeerConnection ||
            this.navigator.mozRTCPeerConnection ||
            this.navigator.webkitRTCPeerConnection);

        this.navigator.RTCIceCandidate = (this.navigator.RTCIceCandidate ||
            this.navigator.mozRTCIceCandidate ||
            this.navigator.webkitRTCIceCandidate);

        this.navigator.RTCSessionDescription = (this.navigator.RTCSessionDescription ||
            this.navigator.mozRTCSessionDescription ||
            this.navigator.webkitRTCSessionDescription);

    }

    videoconnect(video) {
        let video1 = video;
        let constraints = {
            video: {
                width: 423,
                height: 317
            },
            audio: true
        };
        this.connect(video1, constraints);
    }

    updateMeter(pct) {
        var meter = document.getElementById('meter');
        if (!meter) {
            return;
        }
        meter.style.width = pct + '%';
    }

    connect(video: any, constraints: any) {
        let self = this;
        let AudioContext = window.AudioContext || window.webkitAudioContext;
        let observable = from(this.navigator.mediaDevices.getUserMedia(constraints));
        observable.subscribe((stream:Response) => {
            video.muted = true;
            video.srcObject = stream;
            self.localStream = video.srcObject;
            let audioContext = new AudioContext();
            let analyser = audioContext.createAnalyser();
            let mediaStreamSource = audioContext.createMediaStreamSource(stream);
            let processor = audioContext.createScriptProcessor(2048, 1, 1);

            mediaStreamSource.connect(analyser);
            analyser.connect(processor);
            processor.connect(audioContext.destination);
            processor.onaudioprocess = function (e) {
                var inputData = e.inputBuffer.getChannelData(0);
                var inputDataLength = inputData.length;
                var total = 0;
                for (var i = 0; i < inputDataLength; i++) {
                    total += Math.abs(inputData[i++]);
                }

                var rms = Math.sqrt(total / inputDataLength);
                self.updateMeter(rms * 100);
            }
            this._currentStream.next(video);
        }, (err) => {
            console.log('Failed to get stream', err);
        });
    }

    stopVideo(stream) {
        if (stream) {
            stream.pause();
            this.stopAudio(stream);
        }
    }

    stopAudio(stream) {
        // if (stream.paused)
        //     this.audioContext.close();
    }

    wsConnect(url) {
        let self = this;
        this.wsConnection = new WebSocket(url);
        this.wsConnection.binaryType = 'arraybuffer';

        this.wsConnection.onopen = function () {
            console.log('wsConnection.onopen');

            self.peerConnection = new RTCPeerConnection(self.peerConnectionConfig);
            self.peerConnection.onicecandidate = self.gotIceCandidate;

            let localTracks = self.localStream.getTracks();
            for (let localTrack in localTracks) {
                self.peerConnection.addTrack(localTracks[localTrack], self.localStream);
            }

            self.peerConnection.createOffer(self.gotDescription.bind(self), self.errorHandler);


        }

        this.wsConnection.onmessage = function (evt) {
            let msgJSON = JSON.parse(evt.data);

            let msgStatus = Number(msgJSON['status']);
            let msgCommand = msgJSON['command'];

            if (msgStatus != 200) {
                self.stopPublisher();
            }
            else {
                let sdpData = msgJSON['sdp'];
                if (sdpData !== undefined) {
                    self.peerConnection.setRemoteDescription(new RTCSessionDescription(sdpData), function () {
                        self.peerConnection.createAnswer(self.gotDescription.bind(self), self.errorHandler);
                    }, self.errorHandler);
                }

                let iceCandidates = msgJSON['iceCandidates'];
                if (iceCandidates !== undefined) {
                    for (var index in iceCandidates) {
                        self.peerConnection.addIceCandidate(new RTCIceCandidate(iceCandidates[index]));
                    }
                }
            }

            if (self.wsConnection != null)
                self.wsConnection.close();
            self.wsConnection = null;
        }

        this.wsConnection.onclose = function () {
            console.log('wsConnection.onclose');
        }

        this.wsConnection.onerror = function (evt) {
            self.stopPublisher();
        }
    }

    getUserMediaSuccess(stream)
    {
        try{
            this.localVideo.srcObject = stream;
        } catch (error){
            this.localVideo.src = window.URL.createObjectURL(stream);
        }
    }

    startPublisher() {
        this.streamInfo = {applicationName: APPLICATION_NAME, streamName: this.getStreamName, sessionId: '[empty]'};
        this.wsConnect(this.wsURL);
    }

    stopPublisher() {
        if (this.peerConnection != null)
            this.peerConnection.close();
        this.peerConnection = null;

        if (this.wsConnection != null)
            this.wsConnection.close();
        this.wsConnection = null;
    }

    start() {
        if (this.peerConnection == null) {
            this.setStreamName();
            this.startPublisher();
        } else {
            this.stopPublisher();
        }
    }

    gotIceCandidate(event) {
        if (event.candidate != null) {
            console.log('gotIceCandidate: ' + JSON.stringify({'ice': event.candidate}));
        }
    }

    gotDescription(description) {

        let self = this;
        let enhanceData = <any>{};

        if (this.audioBitrate !== undefined)
            enhanceData.audioBitrate = Number(this.audioBitrate);
        if (this.videoBitrate !== undefined)
            enhanceData.videoBitrate = Number(this.videoBitrate);
        if (this.videoFrameRate !== undefined)
            enhanceData.videoFrameRate = Number(this.videoFrameRate);


        /* Removing as temporary fix for Chrome 127 update. Still needs testing to ensure nothing else breaks */
        // description.sdp = this.enhanceSDP(description.sdp, enhanceData);

        this.peerConnection.setLocalDescription(description, function () {
            self.wsConnection.send('{"direction":"publish", "command":"sendOffer", "streamInfo":' + JSON.stringify(self.streamInfo) + ', "sdp":' + JSON.stringify(description) + ', "userData":' + JSON.stringify(self.userData) + '}');
        }, function (err) {
            console.log('set description error');
        });
    }

    addAudio(sdpStr, audioLine) {
        var sdpLines = sdpStr.split(/\r\n/);
        var sdpSection = 'header';
        var hitMID = false;
        var sdpStrRet = '';
        var done = false;

        for (var sdpIndex in sdpLines) {
            var sdpLine = sdpLines[sdpIndex];

            if (sdpLine.length <= 0)
                continue;


            sdpStrRet += sdpLine;
            sdpStrRet += '\r\n';

            if ('a=rtcp-mux'.localeCompare(sdpLine) == 0 && done == false) {
                sdpStrRet += audioLine;
                done = true;
            }


        }
        return sdpStrRet;
    }

    addVideo(sdpStr, videoLine) {
        var sdpLines = sdpStr.split(/\r\n/);
        var sdpSection = 'header';
        var hitMID = false;
        var sdpStrRet = '';
        var done = false;

        var rtcpSize = false;
        var rtcpMux = false;

        for (var sdpIndex in sdpLines) {
            var sdpLine = sdpLines[sdpIndex];

            if (sdpLine.length <= 0)
                continue;

            if (sdpLine.includes('a=rtcp-rsize')) {
                rtcpSize = true;
            }

            if (sdpLine.includes('a=rtcp-mux')) {
                rtcpMux = true;
            }

        }

        for (var sdpIndex in sdpLines) {
            var sdpLine = sdpLines[sdpIndex];

            sdpStrRet += sdpLine;
            sdpStrRet += '\r\n';

            if (('a=rtcp-rsize'.localeCompare(sdpLine) == 0) && done == false && rtcpSize == true) {
                sdpStrRet += videoLine;
                done = true;
            }

            if ('a=rtcp-mux'.localeCompare(sdpLine) == 0 && done == true && rtcpSize == false) {
                sdpStrRet += videoLine;
                done = true;
            }

            if ('a=rtcp-mux'.localeCompare(sdpLine) == 0 && done == false && rtcpSize == false) {
                done = true;
            }

        }
        return sdpStrRet;
    }

    enhanceSDP(sdpStr, enhanceData) {
        var sdpLines = sdpStr.split(/\r\n/);
        var sdpSection = 'header';
        var hitMID = false;
        var sdpStrRet = '';

        //console.log("Original SDP: "+sdpStr);

        // Firefox provides a reasonable SDP, Chrome is just odd
        // so we have to doing a little mundging to make it all work
        // * THIS_IS_SDPARTA is NOT a school constant; it's Session Description Protocols added by Firefox
        if (!sdpStr.includes('THIS_IS_SDPARTA') || this.videoChoice.includes('VP9')) {
            for (var sdpIndex in sdpLines) {
                var sdpLine = sdpLines[sdpIndex];

                if (sdpLine.length <= 0)
                    continue;

                var doneCheck = this.checkLine(sdpLine);
                if (!doneCheck)
                    continue;

                sdpStrRet += sdpLine;
                sdpStrRet += '\r\n';

            }
            sdpStrRet = this.addAudio(sdpStrRet, this.deliverCheckLine(this.audioChoice, 'audio'));
            sdpStrRet = this.addVideo(sdpStrRet, this.deliverCheckLine(this.videoChoice, 'video'));
            sdpStr = sdpStrRet;
            sdpLines = sdpStr.split(/\r\n/);
            sdpStrRet = '';
        }

        for (var sdpIndex in sdpLines) {
            var sdpLine = sdpLines[sdpIndex];

            if (sdpLine.length <= 0)
                continue;

            if (sdpLine.indexOf('m=audio') == 0 && this.audioIndex != -1) {
                this.audioMLines = sdpLine.split(' ');
                sdpStrRet += this.audioMLines[0] + ' ' + this.audioMLines[1] + ' ' + this.audioMLines[2] + ' ' + this.audioIndex + '\r\n';
                continue;
            }

            if (sdpLine.indexOf('m=video') == 0 && this.videoIndex != -1) {
                this.audioMLines = sdpLine.split(' ');
                sdpStrRet += this.audioMLines[0] + ' ' + this.audioMLines[1] + ' ' + this.audioMLines[2] + ' ' + this.videoIndex + '\r\n';
                continue;
            }

            sdpStrRet += sdpLine;

            if (sdpLine.indexOf('m=audio') === 0) {
                sdpSection = 'audio';
                hitMID = false;
            }
            else if (sdpLine.indexOf('m=video') === 0) {
                sdpSection = 'video';
                hitMID = false;
            }
            else if (sdpLine.indexOf('a=rtpmap') == 0) {
                sdpSection = 'bandwidth';
                hitMID = false;
            }

            if (sdpLine.indexOf('a=mid:') === 0 || sdpLine.indexOf('a=rtpmap') == 0) {
                if (!hitMID) {
                    if ('audio'.localeCompare(sdpSection) == 0) {
                        if (enhanceData.audioBitrate !== undefined) {
                            sdpStrRet += '\r\nb=CT:' + (enhanceData.audioBitrate);
                            sdpStrRet += '\r\nb=AS:' + (enhanceData.audioBitrate);
                        }
                        hitMID = true;
                    }
                    else if ('video'.localeCompare(sdpSection) == 0) {
                        if (enhanceData.videoBitrate !== undefined) {
                            sdpStrRet += '\r\nb=CT:' + (enhanceData.videoBitrate);
                            sdpStrRet += '\r\nb=AS:' + (enhanceData.videoBitrate);
                            if (enhanceData.videoFrameRate !== undefined) {
                                sdpStrRet += '\r\na=framerate:' + enhanceData.videoFrameRate;
                            }
                        }
                        hitMID = true;
                    }
                    else if ('bandwidth'.localeCompare(sdpSection) == 0) {
                        var rtpmapID;
                        rtpmapID = this.getrtpMapID(sdpLine);
                        if (rtpmapID !== null) {
                            var match = rtpmapID[2].toLowerCase();
                            if (('vp9'.localeCompare(match) == 0) || ('vp8'.localeCompare(match) == 0) || ('h264'.localeCompare(match) == 0) ||
                                ('red'.localeCompare(match) == 0) || ('ulpfec'.localeCompare(match) == 0) || ('rtx'.localeCompare(match) == 0)) {
                                if (enhanceData.videoBitrate !== undefined) {
                                    sdpStrRet += '\r\na=fmtp:' + rtpmapID[1] + ' x-google-min-bitrate=' + (enhanceData.videoBitrate) + ';x-google-max-bitrate=' + (enhanceData.videoBitrate);
                                }
                            }

                            if (('opus'.localeCompare(match) == 0) || ('isac'.localeCompare(match) == 0) || ('g722'.localeCompare(match) == 0) || ('pcmu'.localeCompare(match) == 0) ||
                                ('pcma'.localeCompare(match) == 0) || ('cn'.localeCompare(match) == 0)) {
                                if (enhanceData.audioBitrate !== undefined) {
                                    sdpStrRet += '\r\na=fmtp:' + rtpmapID[1] + ' x-google-min-bitrate=' + (enhanceData.audioBitrate) + ';x-google-max-bitrate=' + (enhanceData.audioBitrate);
                                }
                            }
                        }
                    }
                }
            }
            sdpStrRet += '\r\n';
        }
        console.log('Resuling SDP: ' + sdpStrRet);
        return sdpStrRet;
    }

    deliverCheckLine(profile, type) {
        var outputString = '';
        for (var line in this.SDPOutput) {
            var lineInUse = this.SDPOutput[line];
            outputString += line;
            if (lineInUse.includes(profile)) {
                if (profile.includes('VP9') || profile.includes('VP8')) {
                    var output = '';
                    var outputs = lineInUse.split(/\r\n/);
                    for (var position in outputs) {
                        var transport = outputs[position];
                        if (transport.indexOf('transport-cc') !== -1 || transport.indexOf('goog-remb') !== -1 || transport.indexOf('nack') !== -1) {
                            continue;
                        }
                        output += transport;
                        output += '\r\n';
                    }

                    if (type.includes('audio')) {
                        this.audioIndex = parseInt(line);
                    }

                    if (type.includes('video')) {
                        this.videoIndex = parseInt(line);
                    }

                    return output;
                }
                if (type.includes('audio')) {
                    this.audioIndex = parseInt(line);
                }

                if (type.includes('video')) {
                    this.videoIndex = parseInt(line);
                }
                return lineInUse;
            }
        }
        return outputString;
    }

    checkLine(line) {
        if (line.startsWith('a=rtpmap') || line.startsWith('a=rtcp-fb') || line.startsWith('a=fmtp')) {
            var res = line.split(':');

            if (res.length > 1) {
                var number = res[1].split(' ');
                if (!isNaN(number[0])) {
                    if (!number[1].startsWith('http') && !number[1].startsWith('ur')) {
                        var currentString = this.SDPOutput[number[0]];
                        if (!currentString) {
                            currentString = '';
                        }
                        currentString += line + '\r\n';
                        this.SDPOutput[number[0]] = currentString;
                        return false;
                    }
                }
            }
        }

        return true;
    }

    setStreamName() {
        this.streamName = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }

    getrtpMapID(line) {
        var findid = new RegExp('a=rtpmap:(\\d+) (\\w+)/(\\d+)');
        var found = line.match(findid);
        return (found && found.length >= 3) ? found : null;
    }

    errorHandler(error) {
        console.log(error);
    }

}

